import React from "react";
import { NavLink, withRouter } from "react-router-dom";
import { withStyles } from '@material-ui/styles';
import { compose } from 'redux';

import withKeepNavigationState from "../../../../hocs/with_keep_navigation_state.js";



import I18n from "../../../../base/i18n.js";

import Routes from "../../../routes.js";

const styles = theme => ({
  signInNav: {
    display: "flex",
    justifyContent: "space-around",
    marginBottom: "42px",
    width: "100%",
    ['@media (max-width: 768px)']: {
      marginTop: "-8px",
      marginBottom: "38px"
    }
  },
  signInNavLink: {
    borderBottom: "2px solid transparent",
    color: theme.palette.black,
    flex: "1 1 50%",
    fontSize: "20px",
    padding: "8px 0",
    textAlign: "center",
    textDecoration: "none",
    textTransform: "uppercase",
    ['@media (max-width: 768px)']: {
      fontSize: "14px",
      padding: "4px 0",
      borderBottomWidth: "1px"
    }
  },
  signInNavLinkActive: {
    borderBottomColor: theme.palette.blueMain
  }
});

const SignInNav = (props) => {
  const { classes, navigationState } = props;

  const onClick = (event, url) => {
    const { history } = props;

    event.preventDefault();
    history.replace({
      pathname: url,
      state: navigationState
    });

  }

  return (
    <nav className = { classes.signInNav }>
      <NavLink to = { {
        pathname: Routes.signIn(),
        state: navigationState
      } }
               className = { classes.signInNavLink }
               activeClassName = { classes.signInNavLinkActive }
               onClick = { (event) => onClick(event, Routes.signIn()) }>
         { I18n.t("shared.authorization") }
      </NavLink>
      <NavLink to = { {
        pathname: Routes.signUp(),
        state: navigationState
      } }
               className = { classes.signInNavLink }
               activeClassName = { classes.signInNavLinkActive }
               onClick = { (event) => onClick(event, Routes.signUp()) } >
        { I18n.t("shared.registration") }
      </NavLink>
    </nav>
  )
}
export default compose(withKeepNavigationState, withRouter, withStyles(styles))(SignInNav)

